EmailFormTextInputView = require "../../common/views/text_input_view"

class EmailFormIntlNumberInputView extends EmailFormTextInputView
  tagName: 'li'

  events:
    'keyup .number_input': 'validateEmailForm'

  initialize: ->
    EmailFormTextInputView::initialize.apply(this, arguments)
    @elementID = ".number_input"
    @template = {number_input_template: true}

module.exports = EmailFormIntlNumberInputView
